import {
  Component,
  effect,
  input,
  signal,
} from '@angular/core';
import {
  PatientProgramModel,
  PatientProgramStatus,
} from '../../core/api/models';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { PatientDataFacadeService } from '../../core/services/patient-data-facade.service';
import { getPatientProgramStatusLabel } from '../../shared/utils/utils';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrl: './programs.component.css',
  standalone: false,
})
export class ProgramsComponent {
  patientID = input.required<string>();

  isLoading: boolean = false;

  selectablePrograms = signal<SelectItem[]>([]);
  selectedProgram: PatientProgramModel | null = null;
  programDropdownPanelStyle: { [key: string]: string } = { width: '100%' };

  constructor(
    private router: Router,
    private patientDataFacade: PatientDataFacadeService
  ) {
    effect(() => {
      if (this.patientID()) {
        this.loadData();
      } else {
        this.router.navigate(['/select-patient']);
      }
    });
  }

  loadData() {
    this.isLoading = true;
    this.patientDataFacade.getPrograms(Number(this.patientID()), { onlyActive: false })
    .subscribe(
      (programs) => {
        console.log('programs', programs);
        this.selectablePrograms.set(
          // filter out deleted programs
          programs
            .filter((program) => !program.IsDeleted)
            .map((program) => ({
              label: this.getProgramOptionLabel(program),
              value: program,
            }))
        );
        console.log('selectablePrograms', this.selectablePrograms());
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching programs', error);
        this.isLoading = false;
      }
      );
  }

  getProgramOptionLabel(program: PatientProgramModel): string {
    const name = program.ProgramName ?? 'No Name';
    const statusLabel = getPatientProgramStatusLabel(
      program.ProgramStatus ?? PatientProgramStatus.Ready
    );
    return `${name} (${statusLabel})`;
  }

  syncProgramDropdownPanelWidth() {
    const dropdownEl = document.getElementById('selectProgram');
    const width = dropdownEl?.offsetWidth;
    if (width && width > 0) {
      this.programDropdownPanelStyle = {
        width: `${width}px`,
        minWidth: `${width}px`,
      };
    }
  }

  onProgramsChange(event: any) {
    if (!event?.value) {
      return;
    }
  }
}
